import { render, staticRenderFns } from "./ClinicClassifyDic.vue?vue&type=template&id=0d833984"
import script from "./ClinicClassifyDic.vue?vue&type=script&lang=js"
export * from "./ClinicClassifyDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicClassifyDic.vue?vue&type=style&index=0&id=0d833984&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d833984')) {
      api.createRecord('0d833984', component.options)
    } else {
      api.reload('0d833984', component.options)
    }
    module.hot.accept("./ClinicClassifyDic.vue?vue&type=template&id=0d833984", function () {
      api.rerender('0d833984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicClassifyDic.vue"
export default component.exports